// Rysowanie robota w probie: korpus z detalami, potem czesci na WALACH
// (kola, zebatki, sprockety) - kazda w ukladzie swojego walu, wiec widac ruch
// przekladni i lancuchow, a nie tylko kol.

import { placeChassisParts, type RobotHandles } from '../physics/compileRobot';
import { METERS_PER_GRID } from '../physics/units';
import type { Camera } from './camera';
import { drawGearMember } from './drawGearTrain';
import { drawPart } from './partArt';

export function drawRobot(
  ctx: CanvasRenderingContext2D,
  camera: Camera,
  handles: RobotHandles,
): void {
  for (const part of placeChassisParts(handles)) {
    drawPart(ctx, camera, {
      definition: part.definition,
      originX: part.originX,
      originY: part.originY,
      angle: part.angle,
    });
  }

  // Czesci osadzone na walach - wspolny renderer z demo przekladni.
  for (const shaft of handles.shafts) {
    const position = shaft.body.getPosition();
    const grid = { x: position.x / METERS_PER_GRID, y: position.y / METERS_PER_GRID };
    const angle = shaft.body.getAngle();
    for (const member of shaft.members) {
      drawGearMember(ctx, camera, { typeId: member.instance.typeId, shaft: grid, angle });
    }
  }
}